import { plainSortObject } from "./plainSortObject.js";
const stableStringifyObject = (objectValue) => {
  return JSON.stringify(objectValue, (_, value) => {
    if (typeof value === "object" && value !== null && !Array.isArray(value)) {
      return plainSortObject(value);
    }
    return value;
  });
};
export {
  stableStringifyObject
};
//# sourceMappingURL=stableStringifyObject.js.map